export { ForgeModuleIcon } from './src/components/forge-module-icon';
